import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Text } from 'ilenia';
export var SignupInfo = function (props) {
    return (React.createElement("div", { className: css(styles.layout, props.styles) },
        React.createElement("h2", { className: css(styles.h2) },
            React.createElement(Text, { id: "signup.message.title" })),
        React.createElement("h3", { className: css(styles.h3) },
            React.createElement(Text, { id: "signup.message.items.title" })),
        React.createElement("ul", null,
            React.createElement("li", null,
                React.createElement("p", { className: css(styles.p) },
                    React.createElement(Text, { id: "signup.message.items.1" }))),
            React.createElement("li", null,
                React.createElement("p", { className: css(styles.p) },
                    React.createElement(Text, { id: "signup.message.items.2" }))),
            React.createElement("li", null,
                React.createElement("p", { className: css(styles.p) },
                    React.createElement(Text, { id: "signup.message.items.3" }))))));
};
var styles = StyleSheet.create({
    layout: {
        maxWidth: '318px',
        boxSizing: 'content-box',
        top: '128px',
        margin: '64px 0',
        padding: '0 60px 0 80px',
        color: '#000032',
        fontWeight: 400,
        lineHeight: '24px',
    },
    h2: {
        fontSize: '24px',
        color: '#000032',
        fontWeight: 500,
        marginTop: 0,
        paddingBottom: '13px',
        paddingTop: '24px',
    },
    h3: {
        fontWeight: 500,
    },
    p: {
        fontSize: '16px',
        fontWeight: 300,
        lineHeight: '24px',
        marginBottom: '10px',
        color: '#666666',
    }
});
